import { axiosWithToken } from '../index';

const { REACT_APP_API_GATEWAY, REACT_APP_BACKEND_BRAND } = process.env;

export const getDetailsPrice = async (quoteId: string): Promise<any> => {
  const url = `${REACT_APP_API_GATEWAY}/miles/${REACT_APP_BACKEND_BRAND}/quotes/${quoteId}/pricing-details`;
  return axiosWithToken
    .get(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};
